import React from "react";
import { RxCross2 } from "react-icons/rx";
// import { getCookie, updateDataInDb } from "../../../../../helper";
import { useSelector } from "react-redux";
import { selectLogInUsername } from "../../../../../common/authenticateDashboard/authSlice";
import { updateDataInMongoDb } from "../../../../../services/mongod.data";

const AuthModal = ({ setOpen, authName, setAuthName }) => {
  const sessionUser = useSelector(selectLogInUsername);
  const user = sessionUser?.split("@")[0];
  const AuthHandler = async () => {
    let api_url = `${user}/graph-integration`;
    await updateDataInMongoDb(user, "graph-integration", ["hubspot"],{ authName: authName });

    window.open(
      "https://app.hubspot.com/oauth/authorize?client_id=cb5d21b0-85e5-4274-a540-710c1f9a3449&redirect_uri=https://dashboard.causalfunnels.com/integration/hubspot&scope=crm.lists.read%20crm.objects.contacts.read%20crm.objects.contacts.write%20crm.lists.write"
    );
    // window.open(
    //   "https://app.hubspot.com/oauth/authorize?client_id=cb5d21b0-85e5-4274-a540-710c1f9a3449&redirect_uri=http://localhost:3000/integration/hubspot&scope=crm.lists.read%20crm.objects.contacts.read%20crm.objects.contacts.write%20crm.lists.write"
    // );
  };
  return (
    <div className="relative">
      <div className="bg-gray-800/30 text-black  w-[100%] min-h-[500px] p-5 absolute inset-0 z-10 ">
        <div className="flex items-center justify-center h-full">
          <div className="bg-white rounded-md p-6 basis-2/3 relative">
            <RxCross2
              className="absolute right-3 hover:cursor-pointer"
              onClick={() => setOpen(false)}
            />
            <h2 className="text-2xl font-semibold my-3 mb-4">
              Create a new authentication
            </h2>
            <div className="flex flex-col gap-4">
              <div className="flex flex-col gap-2">
                <label className="text-semibold">
                  Your authentication name
                </label>
                <input
                  type="text"
                  value={authName}
                  className="rounded-md text-sm border-gray-200 text-gray-500"
                  onChange={(e) => setAuthName(e.target.value)}
                />
              </div>
            </div>

            <div className="mt-20 space-x-3 flex justify-end ">
              <button
                className="text-gray-800 rounded-md p-2 px-3 border hover:text-indigo-600 hover:shadow-lg"
                onClick={() => setOpen(false)}
              >
                Cancel
              </button>
              <button
                onClick={AuthHandler}
                className="text-white rounded-md bg-indigo-600 p-2 px-3 hover:bg-indigo-500"
              >
                Create
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthModal;
